<template>
  <a class="cla-checkbox vue-ctrl" @click="onClick"
    :class="{invalid: typeof(invalid) !== 'undefined' && invalid !== false}"
  >
    <input type="checkbox" :id="uniqueId" v-model="isChecked" :checked="isChecked" :name="name" :value="value"/>
    <div class="checkmark"></div>
    <label :for="uniqueId" class="checklabel">{{label}}</label>
    <Tooltip :content="tooltip" v-if="tooltip"></Tooltip>
  </a>
</template>

<script>
import Tooltip from "./Tooltip";
import Utils from "../services/utils";

export default {
  name: "Checkbox",
  props: ["id", "name", "label", "checked", "value", "tooltip", "invalid"],
  components: {
    Tooltip
  },
  data() {
    return {
      isChecked: false,
    };
  },
  computed : {
    uniqueId () {
      return this.id || Utils.getComponentId(this);
    }
  },
  methods: {
    onClick: function(e) {
      this.isChecked = !this.isChecked;
      this.$emit("input", this.isChecked);
      this.$emit("change", { sender: this, checked: this.isChecked });
    }
  },
  mounted() {
    this.isChecked = this.$props.checked ? true : false;
  },
  watch: {
    checked (val) {
      this.isChecked = !!val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cla-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #323232;
    font-weight: 325;
    margin-bottom: 5px;
    position: relative;
    margin-right: 16px;
}

.cla-checkbox .checkmark {
    width: 24px;
    min-width: 24px;
    height: 24px;
    border: 1px solid #323232;
    background-color: white;
    margin-right: 8px;
}

@media screen and (max-width: 1160px){
  .cla-checkbox .checkmark {
      width: 20px;
      min-width: 20px;
      height: 20px;
    }
  }

.cla-checkbox input[type=checkbox]:checked+.checkmark {
    background-image: url("data:image/svg+xml,%3Csvg width='17' height='13' viewBox='0 0 17 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.949219 5.27148L6.44922 10.7715L15.9492 1.27148' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A");
    background-size: 17px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #2655ff;
    border: none;
}

.cla-checkbox .checklabel {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 100;
}

.cla-checkbox > input[type=checkbox] {
    display:none;
}

.cla-checkbox > .tooltip {
  margin-top: 0;
}

.cla-checkbox.invalid > .checklabel {
  color: #d22c2c;
}
</style>